export default __webpack_public_path__ + "static/media/Legguards of the Bloodlust.3128f4d7.jpg";